import React, { useState, useEffect, useCallback } from "react";
import { Card, Row, Col, Form, Spinner, Button } from "@themesberg/react-bootstrap";
import { postApi } from "../../redux/api";
import CustomTable from "../../components/CustomTable";
import ResponsiveContainer from "../../components/ResponsiveContainer";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

function ContractorList() {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchData = useCallback(() => {
    setLoading(true);
    postApi("contractors/list", { search })
      .then((resp) => {
        if (resp.success && resp.result) {
          setRecords(resp.result);
        } else {
          setRecords([]);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [search]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const fields = [
    {
      title: "S/N",
      custom: true,
      component: (item) => records.indexOf(item) + 1,
    },
    {
      title: "Contractor Code",
      value: "contractor_code",
    },
    {
      title: "RC No",
      value: "rc_no",
    },
    {
      title: "Name",
      value: "contractor_name",
    },
    {
      title: "Phone",
      value: "contractor_phone",
    },
    {
      title: "TIN",
      value: "contractor_tin_no",
    },
    {
      title: "Email",
      value: "contractor_email",
    },
    {
      title: "Address",
      value: "contractor_address",
    },
    {
      title: "Action",
      style: { minWidth: "80px", textAlign: "center" },
      component: (item) => (
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => navigate(Routes.contractorManagement.create, { state: { contractor_code: item.contractor_code } })}
        >
          <FontAwesomeIcon icon={faEdit} className="me-1" />
          Edit
        </Button>
      ),
    },
  ];

  return (
    <ResponsiveContainer>
      <Card>
        <Card.Body>
          <Row className="align-items-center mb-3">
            <Col>
              <h5 className="mb-0">Contractor Management</h5>
            </Col>
            <Col xs="auto">
              <Button
                variant="success"
                size="sm"
                onClick={() => navigate(Routes.contractorManagement.create)}
              >
                Create New Contractor
              </Button>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} md={6}>
              <Form.Control
                type="text"
                placeholder="Search by name, phone, TIN, or contractor code..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>
          </Row>

          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <CustomTable fields={fields} data={records} />
          )}
        </Card.Body>
      </Card>
    </ResponsiveContainer>
  );
}

export default ContractorList;
